import React from "react"
import { useTranslation } from "react-i18next"

import type { JourneyStep } from "../../helpers/form-summary"

// Trigger → wait → send, top to bottom, with a rail joining the steps.
export function ReviewJourney({ steps }: { steps: JourneyStep[] }) {
  const { t } = useTranslation()
  return (
    <ol aria-label={t("settingsAutomation.review.journey.label")} className={"m-0 flex list-none flex-col p-0"}>
      {steps.map((step, index) => (
        <li key={step.key} className={"relative flex gap-3 pb-3 last:pb-0"}>
          {index < steps.length - 1 && (
            <span
              aria-hidden={"true"}
              className={"absolute bottom-0 left-3 top-6 w-px -translate-x-1/2 bg-gray-200"}
            />
          )}
          <span
            aria-hidden={"true"}
            className={
              "relative inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-bg text-xs font-semibold text-primary-strong"
            }
          >
            {index + 1}
          </span>
          <span className={"flex min-w-0 flex-col text-sm"}>
            <span className={"font-medium"}>{step.title}</span>
            <span className={"break-words text-gray-600"}>{step.text}</span>
          </span>
        </li>
      ))}
    </ol>
  )
}
